import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import MenuBook from '@material-ui/icons/MenuBook';
import ExtensionIcon from '@material-ui/icons/Extension';
import MapIcon from '@material-ui/icons/MyLocation';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
	Settings as SidebarSettings,
	UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import {
	Sidebar,
	sidebarConfig,
	SidebarDivider,
	SidebarGroup,
	SidebarItem,
	SidebarPage,
	SidebarScrollWrapper,
	SidebarSpace,
	useSidebarOpenState,
	Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import GroupIcon from '@material-ui/icons/People';
import ArchitectureIcon from './Icons/ArchitectureIcon';
// import SchoolIcon from '@material-ui/icons/School';
// import DoneAllIcon from '@material-ui/icons/DoneAll';
// import { InsightsSidebarItem } from '@spotify/backstage-plugin-insights'

const useSidebarLogoStyles = makeStyles({
	root: {
		width: sidebarConfig.drawerWidthClosed,
		height: 3 * sidebarConfig.logoHeight,
		display: 'flex',
		flexFlow: 'row nowrap',
		alignItems: 'center',
		marginBottom: -14,
	},
	link: {
		width: sidebarConfig.drawerWidthClosed,
		marginLeft: 24,
	},
});

const SidebarLogo = () => {
	const classes = useSidebarLogoStyles();
	const { isOpen } = useSidebarOpenState();

	return (
		<div className={classes.root}>
			<Link to="/" underline="none" className={classes.link} aria-label="Home">
				{isOpen ? <LogoFull /> : <LogoIcon />}
			</Link>
		</div>
	);
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
	<SidebarPage>
		<Sidebar>
			<SidebarLogo />
			<SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
				<SidebarSearchModal />
			</SidebarGroup>
			<SidebarDivider />
			<SidebarGroup label="Menu" icon={<MenuIcon />}>
				<SidebarItem icon={HomeIcon} to="/" text="Home" />
				{/* Global nav, not org-specific */}
				<MyGroupsSidebarItem
					singularTitle="My Group"
					pluralTitle="My Groups"
					icon={GroupIcon}
				/>
				<SidebarItem icon={MenuBook} to="catalog" text="Catalog" />
				<SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
				<SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
				{/* End global nav */}
				<SidebarDivider />
				{/* <SidebarItem icon={SchoolIcon} to='skill-exchange' text='Skill Exchange' />
        <SidebarItem icon={DoneAllIcon} to='soundcheck' text='Soundcheck' />
				<InsightsSidebarItem />
        <SidebarDivider /> */}
				<SidebarScrollWrapper>
					<SidebarItem icon={MapIcon} to="tech-radar" text="Tech Radar" />
					<SidebarItem
						icon={AccountTreeIcon}
						to="architecture-principles"
						text="Architecture"
					/>
					<SidebarItem
						icon={LibraryBooks}
						to="docs/default/component/moonpig-ladr"
						text="LADRs"
					/>
					<SidebarItem
						icon={ArchitectureIcon}
						to="guidelines"
						text="Guidelines"
					/>
				</SidebarScrollWrapper>
			</SidebarGroup>
			<SidebarSpace />
			<SidebarDivider />
			<SidebarGroup>
				<NotificationsSidebarItem />
			</SidebarGroup>
			<SidebarGroup
				label="Settings"
				icon={<UserSettingsSignInAvatar />}
				to="/settings"
			>
				<SidebarSettings />
			</SidebarGroup>
		</Sidebar>
		{children}
	</SidebarPage>
);
